var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { McLogout } from './McLogout.js';
import { StorageManager, StorageType } from './StorageManger.js';
/**For avaiable tags to document see https://typedoc.org/documents/Tags.html */
/** @private */
function required(target, propertyKey) {
  // This function will be called when the decorator is applied to a property.
  // 'target' is the constructor function for a static member or the prototype for an instance member.
  // 'propertyKey' is the name of the decorated property.
  // You can perform actions or modifications here.
  // For example, you can add some metadata to the property.
  // Example: Adding a metadata key to the property.
  //  Reflect.defineMetadata('required', 'some value', target, propertyKey);
  let key = `__${propertyKey}__required`;
  target[key] = true;
}
/**Options to configure the virtual keyboard*/
export class VirtualKeyboardOptions {
  constructor() {
    /**REQUIRED. Indicates where to store the enabled state once the redirection happens. undefined will not store it*/
    this.storage = StorageType.LocalStorage;
    /**Indicates the key/name to use to store the enabled state once the redirection happens.*/
    this.storageKey = 'mx1.virtualkeyboard.enabled';
    /**Indicates if the storage will be deleted on logout. Default true*/
    this.storageDeleteOnLogout = true;
  }
}
/**Different configurations ` that can be used on {@link Authentication} */
export class AuthenticationOptions {
  constructor() {
    /**REQUIRED. relative url where the user will be redirectd after server side processing. Tipically used to create the local session and perform the redirection
     * * @example
     *  /create-session
     */
    this.afterLoginRedirectTo = "";
    /**OPTIONAL. Indicates if claims are stored in storage in the frontend*/
    this.claimsStoreLocally = true;
    /**The backend endpoint of your app that will handle token refresh. Relative to backendservices
    * Default: /api/idm/token-refresh
    */
    this.refreshUrl = '/api/idm/token-refresh';
    /**The configId used to retrrieve federation options. If missing the default config will be used
     */
    this.configId = null;
    /**Indicates if ect lookup for okta settings will be done at the stack or customer level
     * true: customer level
     * false: stack level
     * NOTE: Federation options are retrieve based on configid
     */
    this.authPerCustomer = false;
    /**The backend endpoint that will receive the code nd exchange it for a token. Relative to backendservices
     */
    this.createSessionUrl = "/api/idm/code-exchange";
    /**The storage to use (localStorage or sessionStorage) or anything implemeting Storage when managing claims and other data in the browesr
     */
    this.storage = localStorage;
    /**The url that can returns claims and id claims
    /**The path to the claims backendurl. Relative to backendServices
    */
    this.claimsUrl = "/api/idm/claims";
    /**REQUIRED. The backend services base urls.
     * This will be used as base url to call the token token exchange, token refresh , logout and claims
     */
    this.backendServices = [];
    /**The path to the logout backendurl. Relative to backendServices*/
    this.backendServiceLogoutUrl = "/api/idm/logout";
    /**True will use a built-in bootstrap dailog warning timeout screen. False will not*/
    this.useBuiltInTimeoutDialogBox = false;
    /**The root path of the application. all urls will be relative to this.
    * @default /api/idm/token-refresh
    */
    this.rootPath = "/";
    /**Indicates if the application idle timer is handled by the lbirary or by the consumer application
     * Default: true
     * true: The lbirary will handle the idle timer and will show the modal or raise the event
     * false: No timer will be run and is up to the application to show the modal and logout the user
     */
    this.useBuiltInApplicationIdleTimer = true;
    /**OPTIONAL. The value of the idle timeout. 60 seconds before this value  the warning modal screen will be triggered*/
    this.idleTimeoutSeconds = 0;
    /**OPTIONAL.The relative or absolute url that will be used when the user clicks the back button on the login screen. "" current url will be used. Default undefined.
     */
    this.referrer = undefined;
  }
}
__decorate([required], AuthenticationOptions.prototype, "ssoUrl", void 0);
__decorate([required], AuthenticationOptions.prototype, "sso_serviceUrl", void 0);
__decorate([required], AuthenticationOptions.prototype, "loginUrl", void 0);
__decorate([required], AuthenticationOptions.prototype, "app", void 0);
__decorate([required], AuthenticationOptions.prototype, "environmentName", void 0);
__decorate([required], AuthenticationOptions.prototype, "backendServices", void 0);
/**The styorage type of usernames*/
export var RememberUserNamesStorage = /*#__PURE__*/function (RememberUserNamesStorage) {
  /**Usernames will be store in localStorage*/
  RememberUserNamesStorage["LocalStorage"] = "localStorage";
  /**Usernames will be store in cookies*/
  RememberUserNamesStorage["Cookies"] = "cookies";
  return RememberUserNamesStorage;
}(RememberUserNamesStorage || {});
/** @private */
export let Names = /*#__PURE__*/(() => {
  class Names {}
  Names.CodeVerifier = "mx1.code_verifier";
  Names.Claims = "mx1.claims";
  Names.IdClaims = "mx1.id_claims";
  Names.Expires = "mx1.expires";
  Names.ExpiresIn = "mx1.expiresIn";
  Names.ParsedToken = "parsed_token";
  Names.RedirectTo = "redirectTo";
  Names.RedirectToPrevious = "redirectTo-previous";
  Names.LoginHintStorage = "mx1.lh";
  /**Structure used to received the token*/
  return Names;
})();
export class TokenRefresh {}
export var Environments = /*#__PURE__*/function (Environments) {
  Environments[Environments["local"] = 0] = "local";
  Environments[Environments["dev"] = 1] = "dev";
  Environments[Environments["qa"] = 2] = "qa";
  Environments[Environments["reg"] = 3] = "reg";
  Environments[Environments["prod"] = 4] = "prod";
  Environments[Environments["stage"] = 5] = "stage";
  Environments[Environments["preprod"] = 6] = "preprod";
  return Environments;
}(Environments || {});
/** Arguments received by the loginCallback function*/
export class LoginCallbackArgs {
  constructor() {
    /**OPTIONAL. If true it will stop the redirection. Default false
     */
    this.abort = false;
  }
}
/** Provides functionality to use the shared login screen and services*/
export class Authentication {
  getTimeoutWarningHtml() {
    let html = `
<div id='uxTimeoutWindow' data-backdrop='static' data-keyboard='false' data-focus='true' class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title"><i class="fa fa-warning neo-warning"></i>&nbsp; Session Timeout Warning</h4>
        </div>
        <div class="modal-body">
            <p>Your session will expire in <span id="uxTimeoutWindowSecondsLeft"></span> seconds. You will be logged out of the system.</p>
            <p>Do you wish to continue this session?</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" id="uxTimeoutWindowContinueButton">Yes, continue</button>
            <button type="submit" class="btn btn-cancel" id="uxTimeoutWindowLogoutButton"   >Logout</button>
        </div>
    </div>
  </div>
</div>
        `;
    return html;
  }
  closeTimeoutWindow(modalContent) {
    $('#uxTimeoutWindow').modal('hide');
    modalContent.remove();
  }
  getSettings() {
    return __awaiter(this, void 0, void 0, function* () {
      let claims = yield this.getClaims();
      let username = claims.sub;
      let url = `${this.options.sso_serviceUrl}/api/auth/settings?username=${username}&app=${this.options.app}&authPerCustomer=${this.options.authPerCustomer}&crmId=${this.options.crmId}`;
      if (this.options.configId) url += `&configId=${this.options.configId}`;
      let response = yield fetch(url);
      if (response.status < 300) {
        let data = yield response.json();
        return data;
      }
      var text = yield response.text();
      throw {
        text: text,
        statusText: response.statusText
      };
    });
  }
  /** Performs the code exchange in the browser. it will also store claims and return the reponse
  */
  codeExchange() {
    return __awaiter(this, void 0, void 0, function* () {
      var code = this.utility.getQueryVariable("code");
      var redirectTo = this.utility.getQueryVariable(Names.RedirectTo);
      let code_verifier = this.utility.readCookie(Names.CodeVerifier);
      let url = `${this.options.sso_serviceUrl}/api/auth/code-exchange`;
      let body = {
        code,
        code_verifier
      };
      let headers = {
        "content-type": "text/json"
      };
      let result = yield fetch(url, {
        headers: headers,
        credentials: 'include',
        method: 'post',
        body: JSON.stringify(body)
      });
      let response = yield result.json();
      response.expiresIn = response["expires_in"];
      this.writeClaims(response);
      return response;
    });
  }
  showTimeoutWindow(seconds) {
    return new Promise(r => {
      const modalContent = document.createElement("div");
      modalContent.innerHTML = this.getTimeoutWarningHtml();
      document.body.appendChild(modalContent);
      document.getElementById("uxTimeoutWindowContinueButton").addEventListener("click", _ => {
        this.closeTimeoutWindow(modalContent);
        r(true);
      });
      document.getElementById("uxTimeoutWindowLogoutButton").addEventListener("click", _ => {
        this.closeTimeoutWindow(modalContent);
        r(false);
      });
      const secondsLeftSpan = document.getElementById("uxTimeoutWindowSecondsLeft");
      let interVal = setInterval(() => {
        secondsLeftSpan.innerText = seconds.toString();
        if (seconds <= 0) {
          this.closeTimeoutWindow(modalContent);
          clearInterval(interVal);
          r(false);
        }
        seconds--;
      }, 1000);
      secondsLeftSpan.innerText = seconds.toString();
      $('#uxTimeoutWindow').modal('show', {
        keyboard: false,
        backdrop: 'static'
      });
    });
  }
  getEnumValues(e) {
    var values = [];
    for (var key in e) {
      if (e.hasOwnProperty(key)) {
        values.push(e[key]);
      }
    }
    return values;
  }
  validate(options) {
    var _a;
    var obj = new AuthenticationOptions();
    var requiredProperties = Object.keys(AuthenticationOptions.prototype).filter(x => x.endsWith("__required"));
    let errors = new Array();
    for (let key of requiredProperties) {
      let propertyName = key.replace("__required", "").replace("__", "");
      if (options[propertyName] == undefined) {
        errors.push(`${propertyName} is required.`);
      }
    }
    if (options.virtualKeyboard) {
      var vkRequiredProperties = Object.keys(VirtualKeyboardOptions.prototype).filter(x => x.endsWith("__required"));
      for (let key of vkRequiredProperties) {
        let propertyName = key.replace("__required", "").replace("__", "");
        if (options.virtualKeyboard[propertyName] == undefined) {
          errors.push(`${propertyName} is required.`);
        }
      }
    }
    if (!options.backendServices || options.backendServices.length == 0) {
      errors.push(`backendServices must have at least one value.`);
    }
    if ((_a = options.virtualKeyboard) === null || _a === void 0 ? void 0 : _a.storage) {
      if (this.getEnumValues(StorageType).indexOf(options.virtualKeyboard.storage) < 0) {
        errors.push(`${options.virtualKeyboard.storage} is not supported for virtualKeyboard.storage. Valid Options are ${this.getEnumValues(StorageType).join(",")}`);
      }
    }
    if (options.authPerCustomer && !options.crmId && !options.configId) {
      errors.push("crmId or configId is required when authPerCustomer is set to true");
    }
    if (errors.length > 0) {
      let errorMessage = "";
      for (let err of errors) {
        errorMessage += err + "\n";
      }
      throw "options not set correctly:\n" + errorMessage;
    }
  }
  getOptions() {
    return this.options;
  }
  /**Create an instance of the {@link Authentication} class
   *
   * @param {AuthenticationOptions} options - The {@link AuthenticationOptions} configuration object
   */
  constructor(options) {
    this.options = options;
    this.version = "1.3.5";
    this.timeoutTimerEnabled = false;
    this.reportAlive = true;
    /** @private */
    this.utility = new IdmUtilities();
    this.validate(options);
    this.environmentName = options.environmentName;
    if (!options.environmentName["length"]) {
      this.environmentName = Environments[options.environmentName];
    }
    var options = new AuthenticationOptions();
    //options.sessionLogoutUrl = options.logoutUrl;
    Object.assign(options, this.options); //send the defaults
    //lets set the default from the class definition and override with the one passed
    if (options.virtualKeyboard) {
      var vk = new VirtualKeyboardOptions();
      Object.assign(vk, options.virtualKeyboard);
      options.virtualKeyboard = vk;
    }
    options.loginUrl = (options.rootPath + options.loginUrl).replace("//", "/");
    options.logoutUrl = (options.rootPath + options.logoutUrl).replace("//", "/");
    options.afterLoginRedirectTo = (options.rootPath + options.afterLoginRedirectTo).replace("//", "/");
    for (let i = 0; i < options.backendServices.length; i++) {
      let url = options.backendServices[i];
      if (url.endsWith("/")) url = url.substring(0, url.length - 1);
      if (!url.startsWith("http")) {
        url = window.location.origin + url;
      }
      if (url.endsWith("/")) url = url.substring(0, url.length - 1);
      url += options.rootPath;
      if (url.endsWith("/")) url = url.substring(0, url.length - 1);
      options.backendServices[i] = url;
    }
    this.options = options;
  }
  /**true if the user has been authenticated and the token as not expired*/
  isAuthenticated() {
    let expires = this.options.storage.getItem(Names.Expires);
    if (!expires) return false;
    var date = new Date(expires);
    var now = new Date();
    if (date < now) return false;
    return true;
  }
  /**If options.claimsStoreLocally=false, you can call this funciton to invalidate the claims memory cache.*/
  clearClaimsCache() {
    this.claims = null;
    this.id_claims = null;
  }
  /**Returns the access_token claims from storage. If !options.claimsStoreLocally, makes a network call. but data will be cached in memory*/
  getClaims() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.options.claimsStoreLocally) {
        if (!this.claims) {
          let x = yield fetch(`${this.options.backendServices[0]}${this.options.claimsUrl}?app=${this.options.app}&authPerCustomer=${this.options.authPerCustomer}&configId=${this.options.configId}&crmId=${this.options.crmId}`, {
            credentials: 'include'
          });
          let json = yield x.json();
          this.claims = json.claims;
          this.id_claims = json.id_claims;
        }
        return this.claims;
      }
      let text = this.options.storage.getItem(Names.Claims);
      if (!text) return {};
      return JSON.parse(text);
    });
  }
  /**Returns the id_token claims from storage. If !options.claimsStoreLocally, makes a network call. but data will be cached in memory*/
  getIdClaims() {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this.options.claimsStoreLocally) {
        if (!this.id_claims) {
          let x = yield fetch(`${this.options.backendServices[0]}${this.options.claimsUrl}?app=${this.options.app}&authPerCustomer=${this.options.authPerCustomer}&configId=${this.options.configId}&crmId=${this.options.crmId}`, {
            credentials: 'include'
          });
          let json = yield x.json();
          this.claims = json.claims;
          this.id_claims = json.id_claims;
        }
        return this.id_claims;
      }
      let text = this.options.storage.getItem(Names.IdClaims);
      if (!text) return {};
      return JSON.parse(text);
    });
  }
  /**Calls all the backend services logout urls*/
  logutBackendServices() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        let promises = new Array();
        for (let url of this.options.backendServices) {
          let logoutUrl = `${url}${this.options.backendServiceLogoutUrl}`;
          console.log("   fetching " + logoutUrl);
          if (this.options.backendServiceLogoutUrl && logoutUrl != this.options.logoutUrl) {
            let p = fetch(logoutUrl, {
              credentials: 'include'
            });
            promises.push(p);
          }
        }
        yield Promise.all(promises);
      } catch (e) {
        console.error("BACKENDS LOGOUT", e);
      }
    });
  }
  /**Redirect the application to the query string value passed during the auth.login call*/
  redirectToCaller() {
    return __awaiter(this, void 0, void 0, function* () {
      //this may happend when security questions are answer. we wat to trigger a login again automatically when the app try to redirect
      //some apps (CA) are redirecting to the home screen again which shows a CA login screen
      if (this.utility.getQueryVariable("reAuth") == "true") {
        let login_hint = this.options.storage.getItem(Names.LoginHintStorage);
        yield this.login(login_hint);
        return;
      }
      let redirectTo = this.options.storage.getItem(Names.RedirectTo) || this.options.rootPath;
      this.options.storage.removeItem(Names.RedirectTo);
      let previous = this.options.storage.getItem(Names.RedirectToPrevious);
      if (previous) {
        this.options.storage.setItem(Names.RedirectTo, this.options.storage.getItem(Names.RedirectToPrevious));
        this.options.storage.removeItem(Names.RedirectToPrevious);
      }
      redirectTo = redirectTo || this.options.rootPath;
      if (redirectTo.startsWith(this.options.loginUrl)) {
        console.error(`We can't redirect to ${redirectTo} since it starts with ${this.options.loginUrl}`);
        window.location.href = this.options.logoutUrl;
        return;
      } else {
        console.log(`Redirecting to ${redirectTo}`);
      }
      window.location.href = redirectTo;
    });
  }
  /**Stores flag to enable the virtual keyboard*/
  virtualKeyboardEnabled() {
    var stg = new StorageManager(this.options.virtualKeyboard.storage);
    stg.setItem(this.options.virtualKeyboard.storageKey, "true");
  }
  /**Stores flag to disable the virtual keyboard*/
  virtualKeyboardDisabled() {
    var stg = new StorageManager(this.options.virtualKeyboard.storage);
    stg.setItem(this.options.virtualKeyboard.storageKey, "false");
  }
  /**Performs the login using the shared log in screen
   * @param login_hint OPTIONAL. The username that will be displayed on the login screen by default. User will be taken to the password step directly
   * @example
   *  luciano.criscola@matrixcare.com
   */
  login() {
    return __awaiter(this, arguments, void 0, function* (login_hint = undefined) {
      if (login_hint && login_hint.indexOf("@") == -1) {
        //validate this simple use case instead the caller is sitll passing the redirectUri that was abandom in 2024r2
        throw "login_hint must be a valid username";
      }
      if (login_hint) {
        this.options.storage.setItem(Names.LoginHintStorage, login_hint);
      }
      let ut = new IdmUtilities();
      var returnUrl = ut.getQueryVariable("ReturnUrl"); //asp.net 
      if (returnUrl) {
        this.options.storage.setItem(Names.RedirectTo, returnUrl);
      }
      returnUrl = ut.getQueryVariable(Names.RedirectTo);
      //we dont want the user to be redirected to the create-session url. This can happend when the redirection is intercepted and change. ie security questions
      if (returnUrl && decodeURIComponent(returnUrl).indexOf(this.options.afterLoginRedirectTo) >= 0) {
        let rd = this.options.storage.getItem(Names.RedirectTo);
        if (rd) {
          this.options.storage.setItem(Names.RedirectToPrevious, this.options.storage.getItem(Names.RedirectTo));
        }
      }
      if (returnUrl) {
        this.options.storage.setItem(Names.RedirectTo, returnUrl);
      }
      var redirectToUrl = '';
      var skipSessionCheck = this.utility.getQueryVariable("skipSessionCheck") || "false";
      let sharedLoginUrl = this.options.ssoUrl;
      var redirectTo = '';
      let afterLoginRedirectTo = this.options.afterLoginRedirectTo;
      let redirectQS = afterLoginRedirectTo || this.utility.getQueryVariable(Names.RedirectTo) || redirectToUrl;
      if (!redirectQS) redirectQS = '/';
      let backendCreateSessionUrl = `${this.options.backendServices[0]}${this.options.createSessionUrl}`;
      //if full url was provided, and the provided one is from not the ui url,
      // if (createSessionUrl.startsWith("http") && !createSessionUrl.startsWith(this.utility.getCurrentHost())) {
      redirectQS = this.utility.getCurrentHost() + redirectQS;
      //}
      redirectQS = encodeURIComponent(redirectQS);
      if (!backendCreateSessionUrl.startsWith('http')) redirectTo = this.utility.getCurrentHost();
      redirectTo += backendCreateSessionUrl + (backendCreateSessionUrl.indexOf("?") >= 0 ? "&" : "?") + Names.RedirectTo + "=" + redirectQS;
      var queryString = "";
      queryString += this.getValueIfNotUndefined("app", this.options.app);
      queryString += this.getValueIfNotUndefined("configId", this.options.configId);
      queryString += this.getValueIfNotUndefined("authPerCustomer", this.options.authPerCustomer);
      queryString += this.getValueIfNotUndefined("hideRememberMe", this.options.hideRememberMe);
      queryString += this.getValueIfNotUndefined("defaultDomain", this.options.defaultDomain);
      let referrer = this.utility.getQueryVariable("referrer");
      if (this.options.referrer != undefined) {
        referrer = this.options.referrer;
        if (referrer == "") referrer = window.location.href;
        if (referrer.indexOf("http") == -1) referrer = this.utility.getCurrentHost() + referrer;
      }
      if (login_hint) {
        queryString += this.getValueIfNotUndefined("login_hint", login_hint);
        if (!referrer) {
          referrer = window.location.href;
        }
      }
      if (referrer) {
        queryString += this.getValueIfNotUndefined("referrer", encodeURIComponent(referrer));
      }
      if (this.options.virtualKeyboard) {
        queryString += this.getValueIfNotUndefined("showOnscreenKeyboard", true);
        let stg = new StorageManager(this.options.virtualKeyboard.storage);
        let enabled = stg.getItem(this.options.virtualKeyboard.storageKey);
        queryString += this.getValueIfNotUndefined("onscreenKeyboardEnabled", enabled);
      }
      queryString += this.getValueIfNotUndefined("blankUsername", this.options.blankUsername);
      queryString += this.getValueIfNotUndefined("rememberMoreThanOneUser", this.options.rememberMoreThanOneUser);
      queryString += this.getValueIfNotUndefined("rememberMoreThanOneUserStorage", this.options.rememberMoreThanOneUserStorage);
      queryString += this.getValueIfNotUndefined("crmId", this.options.crmId);
      let codeVerifier = this.utility.generateCodeVerifier();
      if (this.options.loginCallback) {
        let args = {
          code_verifier: codeVerifier
        };
        var result = this.options.loginCallback(args);
        if (result instanceof Promise) {
          var p = result;
          yield p;
        }
        if (args.abort) return;
        codeVerifier = args.code_verifier;
      }
      let codeChallenge = yield this.utility.generateCodeChallengeFromVerifier(codeVerifier);
      this.utility.writeCookie(Names.CodeVerifier, codeVerifier, null, true);
      queryString += "code_challenge=" + codeChallenge + "&";
      if (this.utility.getQueryVariable("redirectTo")) {
        let query = "?" + decodeURIComponent(this.utility.getQueryVariable("redirectTo"));
        let tracingData = this.utility.getQueryVariable("tracingData", query);
        if (tracingData) {
          queryString += "tracingData=" + tracingData + "&";
        }
      }
      window.location.href = sharedLoginUrl + `?${queryString}skipSessionCheck=` + skipSessionCheck + '&redirectTo=' + encodeURIComponent(redirectTo);
    });
  }
  getValueIfNotUndefined(key, value) {
    if (value == undefined) return "";
    return `${key}=${value}&`;
  }
  /**Calls the options.logoutUrl */
  localLogout(querystring = '') {
    window.top.location.href = this.options.logoutUrl + querystring;
  }
  /** When called from an iframe, it will notify its parent that the app has finish processing the logout
   */
  notifyLogoutCompleted() {
    var host = window.location.origin + this.options.logoutUrl;
    var data = {
      message: "shared-login-logout-completed",
      host: host
    };
    console.log("Notifying logout completed", data);
    window.parent.postMessage(data, "*");
  }
  /**Performs a logout of all applications and services. including sso-service, okta and all apps
  * app1.logout -> middleware.logout - > controller.logout -> js-Authentication.logout -> (1.js-MCLogout.logout|2.+ js-MCLogout.commonLogout) -> sso-service/api/auth/logout -> okta/logout -> sso-service/api/auth/close -> MCLogout.commonLogout -> app2/logout,app3/logout ->  /
  **/
  logout(postLogoutUrl) {
    return __awaiter(this, void 0, void 0, function* () {
      this.reportAlive = false;
      this.stopTimers();
      if (!postLogoutUrl) postLogoutUrl = window.location.origin + this.options.loginUrl + '?skipSessionCheck=true';else if (postLogoutUrl.indexOf("http") == -1) {
        postLogoutUrl = this.utility.getCurrentHost() + postLogoutUrl;
        if (postLogoutUrl.indexOf("?") >= 0) postLogoutUrl += '&skipSessionCheck=true';else postLogoutUrl += '?skipSessionCheck=true';
      }
      console.log("Logging out backend services ...");
      yield this.logutBackendServices();
      console.log("Deleting storage ...");
      this.options.storage.removeItem(Names.IdClaims);
      this.options.storage.removeItem(Names.Claims);
      this.options.storage.removeItem(Names.Expires);
      this.options.storage.removeItem(Names.ExpiresIn);
      this.options.storage.removeItem(Names.RedirectTo);
      this.options.storage.removeItem(Names.RedirectToPrevious);
      this.options.storage.removeItem(Names.LoginHintStorage);
      if (this.options.virtualKeyboard && this.options.virtualKeyboard.storage && this.options.virtualKeyboard.storageDeleteOnLogout) {
        var stg = new StorageManager(this.options.virtualKeyboard.storage);
        stg.removeItem(this.options.virtualKeyboard.storageKey);
      }
      this.notifyLogoutCompleted();
      var mcLogout = new McLogout(this.environmentName);
      console.log("Closing Sessions ....");
      return mcLogout.logout(this.options.sso_serviceUrl, postLogoutUrl, this.options.app, this.options.configId, this.options.authPerCustomer, this.options.crmId);
      console.log("Closing Sessions completed.");
    });
  }
  /**Configure the library  with the following features
   *  Register the logout url in the shared cookie
   *  Configure the keep alive so there is a token refresh request before it expires
   *  Configure idle,so you will get a warning event and automatic logout after x number of inactivity. x is t= retrieved from the access token
   * @param {callback} tokenRefreshCallback - Callback to execute when the token was refreshed!!.<br/>
   * Parameters <br/>
   *  data: {@link TokenRefresh}The number of seconds ramining
   * @param {callback} idleCallback - Callback to execute when there is one minute until idle timeout. Will only be called one useBuiltInApplicationIdleTimer=true<br/>
   * Parameters <br/>
   *  seconds:number
   */
  configure() {
    return __awaiter(this, arguments, void 0, function* (tokenRefreshCallback = undefined, idleCallback = undefined) {
      if (this.isAuthenticated()) {
        this.registerLogout();
        this.configureKeepAlive(x => {
          if (tokenRefreshCallback) {
            tokenRefreshCallback(x);
          }
        });
        if (!this.options.useBuiltInApplicationIdleTimer) {
          this.configureIdle();
        } else {
          this.configureIdle(seconds => __awaiter(this, void 0, void 0, function* () {
            //display warning modal
            //call this.resumeIdleTimeout when clicking continue
            //call logout hen clicking logout
            if (idleCallback) {
              idleCallback(seconds);
            }
            if (this.options.useBuiltInTimeoutDialogBox) {
              let continueResult = yield this.showTimeoutWindow(seconds);
              if (continueResult)
                //yes continue
                {
                  this.resumeIdleTimeout();
                  return;
                } else {
                this.logout('/');
                return;
              }
            }
          }), this.options.idleTimeoutSeconds);
        }
      }
    });
  }
  /**Configure the idle timeout in case you don't call {@link Authentication.configure} */
  configureIdle() {
    return __awaiter(this, arguments, void 0, function* (timeoutCallback = null, timeoutSeconds = 0) {
      if (!this.isAuthenticated()) {
        return;
      }
      if (timeoutSeconds == 0) {
        let timeout = yield this.getTokenLifetimeSeconds();
        timeoutSeconds = +timeout;
      }
      document.addEventListener("mousemove", () => {
        this.debounce(() => this.alive());
      });
      document.addEventListener("keypress", () => {
        this.debounce(() => this.alive());
      });
      this.timeoutTimerEnabled = true;
      this.idleTimeouTimer = setInterval(() => {
        let x = this.utility.readCookie("lastActivity");
        if (!x) {
          console.error("lastActivity not found");
          this.localLogout();
          return;
        }
        var lastActivity = new Date(x);
        if (lastActivity.getFullYear() == 1900) {
          this.localLogout();
          return;
        }
        if (timeoutCallback) {
          var now = new Date();
          var lastActivitySecondsAgo = Math.round((now - lastActivity) / 1000);
          if (lastActivitySecondsAgo % 10 == 0) {
            console.log({
              lastActivitySecondsAgo: lastActivitySecondsAgo,
              timeoutSeconds: timeoutSeconds,
              left: timeoutSeconds - lastActivitySecondsAgo
            });
          }
          if (lastActivitySecondsAgo >= timeoutSeconds) {
            ///on expiration
            this.timeoutTimerEnabled = false;
            console.log("Application timeout");
            this.localLogout();
          } else if (this.timeoutTimerEnabled && lastActivitySecondsAgo >= timeoutSeconds - 60) {
            //1 minute before expiration
            this.reportAlive = false;
            this.timeoutTimerEnabled = false;
            console.log("Application timeout warning");
            timeoutCallback(timeoutSeconds - lastActivitySecondsAgo);
          }
        }
      }, 1000);
    });
  }
  /**Resumes the idle check after you dismiss the timeout warning. Call this if you dont use {@link AuthenticationOptions.useBuiltInTimeoutDialogBox}*/
  resumeIdleTimeout() {
    this.timeoutTimerEnabled = true;
    this.reportAlive = true;
    this.alive();
  }
  debounce(callback, timeout = 500) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(callback, timeout);
  }
  alive() {
    if (this.reportAlive) {
      var date = new Date();
      this.utility.writeCookie("lastActivity", date.toString(), null, true);
    }
  }
  /**Registers your {@link AuthenticationOptions.logoutUrl} */
  registerLogout() {
    this.utility.writeCookie("lastActivity", new Date().toString(), null, true);
    let mcLogout = new McLogout(this.environmentName);
    mcLogout.addLogoutUrlToCookie(window.location.origin + this.options.logoutUrl); //we dont need to wait
  }
  /**Refresh the access token
   * @param [forceRefresh=false] indicates it wants a new refresh token, true will get a new one even if the current one is not expiring
   */
  refreshToken() {
    return __awaiter(this, arguments, void 0, function* (forceRefresh = false, callback) {
      return fetch(`${this.options.backendServices[0]}${this.options.refreshUrl}?forceRefresh=${forceRefresh}&authPerCustomer=${this.options.authPerCustomer}&app=${this.options.app}&configId=${this.options.configId}&crmId=${this.options.crmId}`, {
        credentials: 'include'
      }).then(x => __awaiter(this, void 0, void 0, function* () {
        let status = x.status;
        if (status < 300) {
          try {
            let promises = new Array();
            for (let url of this.options.backendServices.slice(1)) {
              let p = fetch(`${url}${this.options.refreshUrl}?forceRefresh=${forceRefresh}&authPerCustomer=${this.options.authPerCustomer}&app=${this.options.app}&configId=${this.options.configId}&crmId=${this.options.crmId}`, {
                credentials: 'include'
              });
              p.then(s => {
                if (s.status >= 300) {
                  status = s.status; //this will override the main api status so if there is at lease some status error, we login again
                }
              });
              promises.push(p);
            }
            yield Promise.all(promises);
          } catch (e) {
            console.error(e);
          }
        }
        if (status < 300) {
          x.json().then(data => __awaiter(this, void 0, void 0, function* () {
            if (!data.expires) return;
            this.tokenExpiration = new Date(data.expires);
            if (this.options.claimsStoreLocally) {
              this.options.storage.setItem(Names.Claims, JSON.stringify(data.claims));
              this.options.storage.setItem(Names.IdClaims, JSON.stringify(data.id_claims));
            }
            if (data.expiresIn) {
              this.options.storage.setItem(Names.ExpiresIn, data.expiresIn);
            }
            if (data.expires) {
              this.options.storage.setItem(Names.Expires, data.expires);
            }
            callback({
              id_claims: data.id_claims,
              claims: data.claims,
              expires: new Date(data.expires),
              expiresIn: data.expiresIn
            });
          }));
        } else if (status == 401) {
          this.redirectToLoginWithCurrentUrl();
        } else {
          console.error("Error while updating session", x);
          this.redirectToLogoutWithCurrentUrl();
        }
      }), error => {
        console.log("error", error);
      });
    });
  }
  getTokenExpiration() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.tokenExpiration) {
        return new Promise(resolve => resolve(this.tokenExpiration));
      }
      var date = decodeURIComponent(this.options.storage.getItem(Names.Expires));
      if (!date) return null;
      let dt = new Date(date);
      if (isNaN(dt)) return null;
      return dt;
    });
  }
  getTokenLifetimeSeconds() {
    return __awaiter(this, void 0, void 0, function* () {
      var lifetime = +this.options.storage.getItem(Names.ExpiresIn);
      return lifetime;
    });
  }
  tryRefreshToken(callback) {
    return __awaiter(this, void 0, void 0, function* () {
      var expires = yield this.getTokenExpiration();
      if (!expires) return;
      var now = new Date();
      var minutesToExpiration = (expires - now) / 1000 / 60;
      console.log({
        expires: expires,
        minutesToExpiration: minutesToExpiration
      });
      if (minutesToExpiration < 2)
        //try to refresh when its 2 minute to token expiration
        {
          this.refreshToken(false, callback);
        }
    });
  }
  /**
  * Setuups the KeepAlive code that checks if the tokens needs to be refreshed
  */
  configureKeepAlive(callback) {
    this.tryRefreshToken(callback); //refresh the token in case is about to expire before the timer is run
    this.tokenRefreshTimer = setInterval(() => __awaiter(this, void 0, void 0, function* () {
      this.tryRefreshToken(callback);
    }), 30000); // 50000);
  }
  stopTimers() {
    if (this.tokenRefreshTimer) clearInterval(this.tokenRefreshTimer);
    if (this.idleTimeouTimer) clearInterval(this.idleTimeouTimer);
  }
  /**Redirects the user to the login url using the current url as  redirectTo     */
  redirectToLoginWithCurrentUrl() {
    let path = this.utility.getUrlPathEncoded();
    window.top.location.href = `${this.options.loginUrl}?redirectTo=${path}`;
  }
  /**Redirects the user to the logout url using the current url as  redirectTo     */
  redirectToLogoutWithCurrentUrl() {
    let path = this.utility.getUrlPathEncoded();
    this.localLogout(`?redirectTo=${path}`);
  }
  /**
   * Extracts claims from the query string and store values in storage
   */
  extractClaimsFromQueryString() {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        let promises = new Array();
        let code = this.utility.getQueryVariable("code");
        let tracingData = this.utility.getQueryVariable("tracingData");
        for (let url of this.options.backendServices.slice(1)) {
          if (!code) throw `Code was not received from the backend and cannot continue calling the rest of the backends`;
          //redirectTo can be anyting since it wont be follow redirection
          let p = fetch(`${url}${this.options.createSessionUrl}?code=${code}&redirectTo=${window.location.origin}&tracingDat${tracingData}`, {
            credentials: 'include',
            redirect: 'manual'
          });
          promises.push(p);
        }
        yield Promise.all(promises);
      } catch (e) {
        console.error(e);
      }
      let tokenText = `#${Names.ParsedToken}=`;
      let index1 = window.location.href.indexOf(tokenText);
      if (index1 == -1) return Promise.resolve(null);
      let data = window.location.href.substring(index1 + tokenText.length);
      let decodedData = atob(data);
      let obj = JSON.parse(decodedData);
      if (this.options.virtualKeyboard != undefined) {
        var storage = this.options.virtualKeyboard.storage;
        if (storage) {
          var stg = new StorageManager(storage);
          stg.setItem(this.options.virtualKeyboard.storageKey, obj.onscreenkeyboard_enabled.toString());
        }
      }
      let newUrl = window.location.href.replace(window.location.hash, "");
      history.replaceState(null, window.document.title, newUrl);
      return new Promise(r => {
        this.writeClaims(obj);
        let storage = this.options.storage;
        if (this.options.claimsStoreLocally && (!obj.claims || !obj.id_claims)) {
          fetch(`${this.options.backendServices[0]}${this.options.claimsUrl}`, {
            credentials: 'include'
          }).then(x => {
            storage.setItem(Names.Claims, JSON.stringify(x.claims));
            storage.setItem(Names.IdClaims, JSON.stringify(x.id_claims));
            let ret = Object.assign(Object.assign({}, obj), {
              claims: x.claims,
              id_claims: x.id_claims
            });
            r(ret);
          });
        } else {
          r(obj);
        }
      });
    });
  }
  writeClaims(obj) {
    this.options.storage.setItem(Names.Expires, obj.expires.toString());
    this.options.storage.setItem(Names.ExpiresIn, obj.expiresIn.toString());
    if (this.options.claimsStoreLocally) {
      this.options.storage.setItem(Names.Claims, JSON.stringify(obj.claims));
      this.options.storage.setItem(Names.IdClaims, JSON.stringify(obj.id_claims));
    }
  }
  /**When the back button is clicked in shared login, it will send the current keyboard state to the referrer url
   * This method can be used to extract it from the query string and store it locally
   */
  extractVirtualKeyboardStateFromQueryString() {
    if (!this.options.virtualKeyboard) throw `You cant call this method if virutalKeboard is not configured`;
    var enabled = this.utility.getQueryVariable("mx1.vk");
    var stg = new StorageManager(this.options.virtualKeyboard.storage);
    if (enabled != "") {
      stg.setItem(this.options.virtualKeyboard.storageKey, enabled);
    }
  }
}
/**Several utilities used internally but can be helpfull to other devs*/
export class IdmUtilities {
  constructor() {
    this.version = "1.3.5";
  }
  static isMobile() {
    // User agent string method
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // Screen resolution method
    if (!isMobile) {
      let screenWidth = window.screen.width;
      let screenHeight = window.screen.height;
      isMobile = screenWidth < 768 || screenHeight < 768;
    }
    // Touch events method
    if (!isMobile) {
      isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator["msMaxTouchPoints"] > 0;
    }
    // CSS media queries method
    if (!isMobile) {
      let bodyElement = document.getElementsByTagName('body')[0];
      isMobile = window.getComputedStyle(bodyElement).getPropertyValue('content').indexOf('mobile') !== -1;
    }
    return isMobile;
  }
  /** Return a querystring value from the url*/
  getQueryVariable(variable, url = window.location.search) {
    var query = url.substring(1); //startes with ?
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair.slice(1).join("="));
      }
    }
    return "";
  }
  /** Given the unix seconds, it returns a date*/
  epochToDate(ms) {
    var d = new Date(0);
    d.setUTCMilliseconds(ms);
    return d;
  }
  dec2hex(dec) {
    return ("0" + dec.toString(16)).substr(-2);
  }
  //public parseToken(token: string): any {
  //    var base64Url = token.split('.')[1];
  //    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  //    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
  //        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  //    }).join(''));
  //    return JSON.parse(jsonPayload);
  //}
  /**Generates a random code verifier*/
  generateCodeVerifier() {
    var array = new Uint32Array(56 / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, this.dec2hex).join("");
  }
  sha256(plain) {
    // returns promise ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest("SHA-256", data);
  }
  base64urlencode(a) {
    var str = "";
    var bytes = new Uint8Array(a);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  /**Generates a sha256 for the given value*/
  generateCodeChallengeFromVerifier(v) {
    return __awaiter(this, void 0, void 0, function* () {
      var hashed = yield this.sha256(v);
      var base64encoded = this.base64urlencode(hashed);
      return base64encoded;
    });
  }
  /**Returns true if two urls belong to the same root domain
   * @example
   * sameRootDomain('https://app1.matrixcare.com','https://app2.matrixcare.com');
   */
  sameRootDomain(host1, host2) {
    host1 = host1.replace("https://", "");
    host2 = host2.replace("https://", "");
    var index1 = host1.indexOf(":");
    var index2 = host2.indexOf(":");
    if (index1 >= 0) {
      host1 = host1.substring(0, index1);
    }
    if (index2 >= 0) {
      host2 = host2.substring(0, index2);
    }
    index1 = host1.indexOf("/");
    index2 = host2.indexOf("/");
    if (index1 >= 0) {
      host1 = host1.substring(0, index1);
    }
    if (index2 >= 0) {
      host2 = host2.substring(0, index2);
    }
    var parts1 = host1.split(".");
    var parts2 = host2.split(".");
    //checking onlye the last 2 parts of the domain ie: matrixcare me
    if (parts1[parts1.length - 1].toLowerCase() != parts2[parts2.length - 1]) return false;
    if (parts1[parts1.length - 2].toLowerCase() != parts2[parts2.length - 2]) return false;
    return true;
  }
  /**Returns the path and query string encoded
   */
  getUrlPathEncoded() {
    return encodeURIComponent(this.getUrlPath());
  }
  /**Returns the path and query string
   * @example /path/path2?aa=bb
   */
  getUrlPath() {
    return window.location.pathname + window.location.search;
  }
  /**Returns the host name
   * @example https://app1.matrixcare.com
   */
  getCurrentHost() {
    return window.location.protocol + '//' + window.location.host;
  }
  /**Add some seconds to the date*/
  addSecondsToDate(date, seconds) {
    let newDate = new Date(date.getTime() + seconds * 1000);
    return newDate;
  }
  /**a cookie to the domain
   * @param name
   * @param value
   * @param expiresOn  Expiration date UTC or number of seconds since today
   * @param rootDomain Will be written to the root domain or app domain
   */
  writeCookie(name, value, expiresOn = null, rootDomain = false) {
    //let cookieText = `${name}=${encodeURIComponent(value)}; path = /;secure=true`;
    let cookieText = `${name}=${value}; path=/;`;
    if (expiresOn) {
      if (expiresOn instanceof Date) {
        cookieText += ";expires=" + expiresOn.toUTCString();
      } else if (typeof expiresOn === "number") {
        let expiresOnDate = this.addSecondsToDate(new Date(), expiresOn);
        cookieText += ";expires=" + expiresOnDate.toUTCString();
      }
    }
    cookieText += ";SameSite=Lax; Secure;";
    if (rootDomain) {
      let host = window.location.hostname;
      const index = host.indexOf('.');
      if (index >= 0) {
        host = host.substr(index);
        let domainSuffix = ';domain=' + host;
        cookieText += domainSuffix;
      }
    }
    document.cookie = cookieText;
  }
  /**Deletes a cookie*/
  deleteCookie(name, rootDomain = false) {
    this.writeCookie(name, null, new Date('1970-1-1 00:00'), rootDomain);
  }
  /**Reads a cookie*/
  readCookie(name) {
    // Split cookie string and get all individual name=value pairs in an array
    var cookieArr = document.cookie.split(";");
    // Loop through the array elements
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
      if (name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        //return decodeURIComponent(cookiePair[1]);
        return cookiePair[1];
      }
    }
    // Return null if not found
    return null;
  }
}
